/**
 * AUTO-GENERATED by scripts/card-new.mjs.
 * DO NOT EDIT: run `pnpm card:new -- --write-generated` instead.
 */
import { AcidicSlimeCard as generatedCard0 } from '../cards/acidic_slime.js';
import { AncientOakCard as generatedCard1 } from '../cards/ancient_oak.js';
import { AnomalyCard as generatedCard2 } from '../structures/anomaly.js';
import { ArcBoltCard as generatedCard3 } from '../spells/arc-bolt.js';
import { ArcConductorCard as generatedCard4 } from '../overload/arc-conductor.js';
import { AssaultStoolCard as generatedCard5 } from '../cards/assault_stool.js';
import { AssemblyRobotCard as generatedCard6 } from '../swarm/assembly-robot.js';
import { BandageWoundsCard as generatedCard7 } from '../cards/bandage_wounds.js';
import { BannerCaptainCard as generatedCard8 } from '../cards/banner_captain.js';
import { BanyanShootCard as generatedCard9 } from '../cards/banyan_shoot.js';
import { BarrierCard as generatedCard10 } from '../structures/barrier.js';
import { BattleOrderCard as generatedCard11 } from '../cards/battle_order.js';
import { BlackKnightCard as generatedCard12 } from '../cards/black_knight.js';
import { BlackthornSaplingCard as generatedCard13 } from '../cards/blackthorn_sapling.js';
import { BlindAmoebaCard as generatedCard14 } from '../cards/blind_amoeba.js';
import { BorderlandVeteranCard as generatedCard15 } from '../cards/borderland_veteran.js';
import { BuddingBellyCard as generatedCard16 } from '../cards/budding_belly.js';
import { CampaignArmorerCard as generatedCard17 } from '../cards/campaign_armorer.js';
import { CampaignHeraldCard as generatedCard18 } from '../cards/campaign_herald.js';
import { ClockworkOttomanCard as generatedCard19 } from '../cards/clockwork_ottoman.js';
import { ColonyAttackBonusCard as generatedCard20 } from '../cards/colony_attack_bonus.js';
import { ColonyDevourerCard as generatedCard21 } from '../cards/colony_devourer.js';
import { ColonyPredatorCard as generatedCard22 } from '../cards/colony_predator.js';
import { CompostCycleCard as generatedCard23 } from '../cards/compost_cycle.js';
import { ContaminationMapCard as generatedCard24 } from '../cards/contamination_map.js';
import { CoolingDroneCard as generatedCard25 } from '../overload/cooling-drone.js';
import { CrookedMirrorCard as generatedCard26 } from '../cards/crooked_mirror.js';
import { CrushAndStrainCard as generatedCard27 } from '../cards/crush_and_strain.js';
import { DataArchiveCard as generatedCard28 } from '../cards/data_archive.js';
import { DazzlingLampCard as generatedCard29 } from '../cards/dazzling_lamp.js';
import { DeepSampleCard as generatedCard30 } from '../cards/deep_sample.js';
import { DefensiveCircuitCard as generatedCard31 } from '../overload/defensive-circuit.js';
import { DiningTableCard as generatedCard32 } from '../cards/dining_table.js';
import { DishSideboardCard as generatedCard33 } from '../cards/dish_sideboard.js';
import { DividingSlimeCard as generatedCard34 } from '../cards/dividing_slime.js';
import { DropThePianoCard as generatedCard35 } from '../cards/drop_the_piano.js';
import { EmbroideredCoverCard as generatedCard36 } from '../cards/embroidered_cover.js';
import { EmergencyVentCard as generatedCard37 } from '../overload/emergency-vent.js';
import { ErraticReactorCard as generatedCard38 } from '../cards/erratic_reactor.js';
import { EverythingMachineCard as generatedCard39 } from '../swarm/everything-machine.js';
import { FallingDoorCard as generatedCard40 } from '../cards/falling_door.js';
import { ForeignFleshCard as generatedCard41 } from '../cards/foreign_flesh.js';
import { FourLeggedChairCard as generatedCard42 } from '../cards/four_legged_chair.js';
import { FragmentCard as generatedCard43 } from '../swarm/tokens.js';
import { FurnitureCatalogCard as generatedCard44 } from '../cards/furniture_catalog.js';
import { GeneralLevyCard as generatedCard45 } from '../cards/general_levy.js';
import { GentleWateringCard as generatedCard46 } from '../cards/gentle_watering.js';
import { GrandmasBlanketCard as generatedCard47 } from '../cards/grandmas_blanket.js';
import { GreatBanyanCard as generatedCard48 } from '../cards/great_banyan.js';
import { GreatOakSaplingCard as generatedCard49 } from '../cards/great_oak_sapling.js';
import { GrowthSunflowerCard as generatedCard50 } from '../cards/growth_sunflower.js';
import { HeatSinkCard as generatedCard51 } from '../overload/heat-sink.js';
import { HuntersNetCard as generatedCard52 } from '../cards/hunters_net.js';
import { ImpulseFighterCard as generatedCard53 } from '../overload/impulse-fighter.js';
import { IronSafeCard as generatedCard54 } from '../cards/iron_safe.js';
import { IronhideCard as generatedCard55 } from '../units/ironhide.js';
import { JellyBastionCard as generatedCard56 } from '../cards/jelly_bastion.js';
import { JunkBarricadeCard as generatedCard57 } from '../swarm/junk-barricade.js';
import { JunkChestCard as generatedCard58 } from '../cards/junk_chest.js';
import { JunkDealerCard as generatedCard59 } from '../swarm/junk-dealer.js';
import { LeakingClotCard as generatedCard60 } from '../cards/leaking_clot.js';
import { LiquefactionCard as generatedCard61 } from '../cards/liquefaction.js';
import { LiquidCoolingCard as generatedCard62 } from '../overload/liquid-cooling.js';
import { LivingThornbushCard as generatedCard63 } from '../cards/living_thornbush.js';
import { MatureBlackthornCard as generatedCard64 } from '../cards/mature_blackthorn.js';
import { MeltdownCoreCard as generatedCard65 } from '../cards/meltdown_core.js';
import { MercenarySpearmanCard as generatedCard66 } from '../cards/mercenary_spearman.js';
import { MicrodroneCard as generatedCard67 } from '../swarm/tokens.js';
import { MiddaySunCard as generatedCard68 } from '../cards/midday_sun.js';
import { MilitiaCard as generatedCard69 } from '../cards/militia.js';
import { MindlessSlimeCard as generatedCard70 } from '../cards/mindless_slime.js';
import { MnemoslimeCard as generatedCard71 } from '../cards/mnemoslime.js';
import { MorozkoFridgeCard as generatedCard72 } from '../cards/morozko_fridge.js';
import { NurseryFernCard as generatedCard73 } from '../cards/nursery_fern.js';
import { OverclockedScoutCard as generatedCard74 } from '../overload/overclocked-scout.js';
import { OvergrownRootsCard as generatedCard75 } from '../cards/overgrown_roots.js';
import { OvergulperCard as generatedCard76 } from '../cards/overgulper.js';
import { PlantGrowthCard as generatedCard77 } from '../cards/plant_growth.js';
import { PlantLeafCard as generatedCard78 } from '../cards/plant_leaf.js';
import { PlantThornsCard as generatedCard79 } from '../cards/plant_thorns.js';
import { PowerRerouteCard as generatedCard80 } from '../overload/power-reroute.js';
import { PullIntoClotCard as generatedCard81 } from '../cards/pull_into_clot.js';
import { RampantBloomCard as generatedCard82 } from '../cards/rampant_bloom.js';
import { ReaderArmchairCard as generatedCard83 } from '../cards/reader_armchair.js';
import { ReconstructedRobotCard as generatedCard84 } from '../swarm/tokens.js';
import { RecyclingCard as generatedCard85 } from '../swarm/recycling.js';
import { RedZoneCard as generatedCard86 } from '../overload/red-zone.js';
import { ReinforcedMicrodroneCard as generatedCard87 } from '../swarm/tokens.js';
import { RiotBotCard as generatedCard88 } from '../units/riot-bot.js';
import { RiveterCard as generatedCard89 } from '../swarm/riveter.js';
import { RootweaverIvyCard as generatedCard90 } from '../cards/rootweaver_ivy.js';
import { RoyalCrossbowmanCard as generatedCard91 } from '../cards/royal_crossbowman.js';
import { RoyalDecreeCard as generatedCard92 } from '../cards/royal_decree.js';
import { RoyalJellyCard as generatedCard93 } from '../cards/royal_jelly.js';
import { SampleCollectorCard as generatedCard94 } from '../cards/sample_collector.js';
import { ScatterBoltsCard as generatedCard95 } from '../swarm/scatter-bolts.js';
import { ScoutCard as generatedCard96 } from '../units/scout.js';
import { ScrapCard as generatedCard97 } from '../swarm/tokens.js';
import { ScrapHarvesterCard as generatedCard98 } from '../cards/scrap_harvester.js';
import { ScrapTransporterCard as generatedCard99 } from '../swarm/scrap-transporter.js';
import { SectorPulseCard as generatedCard100 } from '../spells/sector-pulse.js';
import { SelfCopyingDroneCard as generatedCard101 } from '../swarm/self-copying-drone.js';
import { ShieldBearerCard as generatedCard102 } from '../cards/shield_bearer.js';
import { SiegeResonatorCard as generatedCard103 } from '../overload/siege-resonator.js';
import { SingleMassCard as generatedCard104 } from '../cards/single_mass.js';
import { SlimeDropletCard as generatedCard105 } from '../cards/slime_droplet.js';
import { SlimeResidueCard as generatedCard106 } from '../cards/slime_residue.js';
import { SlimefallCard as generatedCard107 } from '../cards/slimefall.js';
import { SlipperySlimeCard as generatedCard108 } from '../cards/slippery_slime.js';
import { SmallSlimeCard as generatedCard109 } from '../cards/small_slime.js';
import { SoftSofaCard as generatedCard110 } from '../cards/soft_sofa.js';
import { SparePartCard as generatedCard111 } from '../swarm/spare-part.js';
import { SpringCleaningCard as generatedCard112 } from '../cards/spring_cleaning.js';
import { StarBlossomCard as generatedCard113 } from '../cards/star_blossom.js';
import { ThermalInverterCard as generatedCard114 } from '../cards/thermal_inverter.js';
import { ThornSeedsCard as generatedCard115 } from '../cards/thorn_seeds.js';
import { TitanPrototypeCard as generatedCard116 } from '../overload/titan-prototype.js';
import { TrashCritterCard as generatedCard117 } from '../swarm/trash-critter.js';
import { VenusFlytrapCard as generatedCard118 } from '../cards/venus_flytrap.js';
import { VoltaicAccumulatorCard as generatedCard119 } from '../cards/voltaic_accumulator.js';
import { WanderingHealerCard as generatedCard120 } from '../cards/wandering_healer.js';
import { WeldingPulseCard as generatedCard121 } from '../swarm/welding-pulse.js';
export { AcidicSlimeCard } from '../cards/acidic_slime.js';
export { AncientOakCard } from '../cards/ancient_oak.js';
export { AnomalyCard } from '../structures/anomaly.js';
export { ArcBoltCard } from '../spells/arc-bolt.js';
export { ArcConductorCard } from '../overload/arc-conductor.js';
export { AssaultStoolCard } from '../cards/assault_stool.js';
export { AssemblyRobotCard } from '../swarm/assembly-robot.js';
export { BandageWoundsCard } from '../cards/bandage_wounds.js';
export { BannerCaptainCard } from '../cards/banner_captain.js';
export { BanyanShootCard } from '../cards/banyan_shoot.js';
export { BarrierCard } from '../structures/barrier.js';
export { BattleOrderCard } from '../cards/battle_order.js';
export { BlackKnightCard } from '../cards/black_knight.js';
export { BlackthornSaplingCard } from '../cards/blackthorn_sapling.js';
export { BlindAmoebaCard } from '../cards/blind_amoeba.js';
export { BorderlandVeteranCard } from '../cards/borderland_veteran.js';
export { BuddingBellyCard } from '../cards/budding_belly.js';
export { CampaignArmorerCard } from '../cards/campaign_armorer.js';
export { CampaignHeraldCard } from '../cards/campaign_herald.js';
export { ClockworkOttomanCard } from '../cards/clockwork_ottoman.js';
export { ColonyAttackBonusCard } from '../cards/colony_attack_bonus.js';
export { ColonyDevourerCard } from '../cards/colony_devourer.js';
export { ColonyPredatorCard } from '../cards/colony_predator.js';
export { CompostCycleCard } from '../cards/compost_cycle.js';
export { ContaminationMapCard } from '../cards/contamination_map.js';
export { CoolingDroneCard } from '../overload/cooling-drone.js';
export { CrookedMirrorCard } from '../cards/crooked_mirror.js';
export { CrushAndStrainCard } from '../cards/crush_and_strain.js';
export { DataArchiveCard } from '../cards/data_archive.js';
export { DazzlingLampCard } from '../cards/dazzling_lamp.js';
export { DeepSampleCard } from '../cards/deep_sample.js';
export { DefensiveCircuitCard } from '../overload/defensive-circuit.js';
export { DiningTableCard } from '../cards/dining_table.js';
export { DishSideboardCard } from '../cards/dish_sideboard.js';
export { DividingSlimeCard } from '../cards/dividing_slime.js';
export { DropThePianoCard } from '../cards/drop_the_piano.js';
export { EmbroideredCoverCard } from '../cards/embroidered_cover.js';
export { EmergencyVentCard } from '../overload/emergency-vent.js';
export { ErraticReactorCard } from '../cards/erratic_reactor.js';
export { EverythingMachineCard } from '../swarm/everything-machine.js';
export { FallingDoorCard } from '../cards/falling_door.js';
export { ForeignFleshCard } from '../cards/foreign_flesh.js';
export { FourLeggedChairCard } from '../cards/four_legged_chair.js';
export { FragmentCard } from '../swarm/tokens.js';
export { FurnitureCatalogCard } from '../cards/furniture_catalog.js';
export { GeneralLevyCard } from '../cards/general_levy.js';
export { GentleWateringCard } from '../cards/gentle_watering.js';
export { GrandmasBlanketCard } from '../cards/grandmas_blanket.js';
export { GreatBanyanCard } from '../cards/great_banyan.js';
export { GreatOakSaplingCard } from '../cards/great_oak_sapling.js';
export { GrowthSunflowerCard } from '../cards/growth_sunflower.js';
export { HeatSinkCard } from '../overload/heat-sink.js';
export { HuntersNetCard } from '../cards/hunters_net.js';
export { ImpulseFighterCard } from '../overload/impulse-fighter.js';
export { IronSafeCard } from '../cards/iron_safe.js';
export { IronhideCard } from '../units/ironhide.js';
export { JellyBastionCard } from '../cards/jelly_bastion.js';
export { JunkBarricadeCard } from '../swarm/junk-barricade.js';
export { JunkChestCard } from '../cards/junk_chest.js';
export { JunkDealerCard } from '../swarm/junk-dealer.js';
export { LeakingClotCard } from '../cards/leaking_clot.js';
export { LiquefactionCard } from '../cards/liquefaction.js';
export { LiquidCoolingCard } from '../overload/liquid-cooling.js';
export { LivingThornbushCard } from '../cards/living_thornbush.js';
export { MatureBlackthornCard } from '../cards/mature_blackthorn.js';
export { MeltdownCoreCard } from '../cards/meltdown_core.js';
export { MercenarySpearmanCard } from '../cards/mercenary_spearman.js';
export { MicrodroneCard } from '../swarm/tokens.js';
export { MiddaySunCard } from '../cards/midday_sun.js';
export { MilitiaCard } from '../cards/militia.js';
export { MindlessSlimeCard } from '../cards/mindless_slime.js';
export { MnemoslimeCard } from '../cards/mnemoslime.js';
export { MorozkoFridgeCard } from '../cards/morozko_fridge.js';
export { NurseryFernCard } from '../cards/nursery_fern.js';
export { OverclockedScoutCard } from '../overload/overclocked-scout.js';
export { OvergrownRootsCard } from '../cards/overgrown_roots.js';
export { OvergulperCard } from '../cards/overgulper.js';
export { PlantGrowthCard } from '../cards/plant_growth.js';
export { PlantLeafCard } from '../cards/plant_leaf.js';
export { PlantThornsCard } from '../cards/plant_thorns.js';
export { PowerRerouteCard } from '../overload/power-reroute.js';
export { PullIntoClotCard } from '../cards/pull_into_clot.js';
export { RampantBloomCard } from '../cards/rampant_bloom.js';
export { ReaderArmchairCard } from '../cards/reader_armchair.js';
export { ReconstructedRobotCard } from '../swarm/tokens.js';
export { RecyclingCard } from '../swarm/recycling.js';
export { RedZoneCard } from '../overload/red-zone.js';
export { ReinforcedMicrodroneCard } from '../swarm/tokens.js';
export { RiotBotCard } from '../units/riot-bot.js';
export { RiveterCard } from '../swarm/riveter.js';
export { RootweaverIvyCard } from '../cards/rootweaver_ivy.js';
export { RoyalCrossbowmanCard } from '../cards/royal_crossbowman.js';
export { RoyalDecreeCard } from '../cards/royal_decree.js';
export { RoyalJellyCard } from '../cards/royal_jelly.js';
export { SampleCollectorCard } from '../cards/sample_collector.js';
export { ScatterBoltsCard } from '../swarm/scatter-bolts.js';
export { ScoutCard } from '../units/scout.js';
export { ScrapCard } from '../swarm/tokens.js';
export { ScrapHarvesterCard } from '../cards/scrap_harvester.js';
export { ScrapTransporterCard } from '../swarm/scrap-transporter.js';
export { SectorPulseCard } from '../spells/sector-pulse.js';
export { SelfCopyingDroneCard } from '../swarm/self-copying-drone.js';
export { ShieldBearerCard } from '../cards/shield_bearer.js';
export { SiegeResonatorCard } from '../overload/siege-resonator.js';
export { SingleMassCard } from '../cards/single_mass.js';
export { SlimeDropletCard } from '../cards/slime_droplet.js';
export { SlimeResidueCard } from '../cards/slime_residue.js';
export { SlimefallCard } from '../cards/slimefall.js';
export { SlipperySlimeCard } from '../cards/slippery_slime.js';
export { SmallSlimeCard } from '../cards/small_slime.js';
export { SoftSofaCard } from '../cards/soft_sofa.js';
export { SparePartCard } from '../swarm/spare-part.js';
export { SpringCleaningCard } from '../cards/spring_cleaning.js';
export { StarBlossomCard } from '../cards/star_blossom.js';
export { ThermalInverterCard } from '../cards/thermal_inverter.js';
export { ThornSeedsCard } from '../cards/thorn_seeds.js';
export { TitanPrototypeCard } from '../overload/titan-prototype.js';
export { TrashCritterCard } from '../swarm/trash-critter.js';
export { VenusFlytrapCard } from '../cards/venus_flytrap.js';
export { VoltaicAccumulatorCard } from '../cards/voltaic_accumulator.js';
export { WanderingHealerCard } from '../cards/wandering_healer.js';
export { WeldingPulseCard } from '../swarm/welding-pulse.js';
export const GENERATED_CARD_MODULES = Object.freeze([
    {
        id: 'acidic_slime',
        modulePath: 'packages/cards/src/cards/acidic_slime.ts',
        exportName: 'AcidicSlimeCard',
        behaviorTestPath: 'packages/cards/src/cards/acidic_slime.test.ts',
    },
    {
        id: 'ancient_oak',
        modulePath: 'packages/cards/src/cards/ancient_oak.ts',
        exportName: 'AncientOakCard',
        behaviorTestPath: 'packages/cards/src/cards/ancient_oak.test.ts',
    },
    {
        id: 'anomaly',
        modulePath: 'packages/cards/src/structures/anomaly.ts',
        exportName: 'AnomalyCard',
        behaviorTestPath: 'packages/cards/src/structures/anomaly.test.ts',
    },
    {
        id: 'arc_bolt',
        modulePath: 'packages/cards/src/spells/arc-bolt.ts',
        exportName: 'ArcBoltCard',
    },
    {
        id: 'arc_conductor',
        modulePath: 'packages/cards/src/overload/arc-conductor.ts',
        exportName: 'ArcConductorCard',
    },
    {
        id: 'assault_stool',
        modulePath: 'packages/cards/src/cards/assault_stool.ts',
        exportName: 'AssaultStoolCard',
        behaviorTestPath: 'packages/cards/src/cards/assault_stool.test.ts',
    },
    {
        id: 'assembly_robot',
        modulePath: 'packages/cards/src/swarm/assembly-robot.ts',
        exportName: 'AssemblyRobotCard',
    },
    {
        id: 'bandage_wounds',
        modulePath: 'packages/cards/src/cards/bandage_wounds.ts',
        exportName: 'BandageWoundsCard',
        behaviorTestPath: 'packages/cards/src/cards/bandage_wounds.test.ts',
    },
    {
        id: 'banner_captain',
        modulePath: 'packages/cards/src/cards/banner_captain.ts',
        exportName: 'BannerCaptainCard',
        behaviorTestPath: 'packages/cards/src/cards/banner_captain.test.ts',
    },
    {
        id: 'banyan_shoot',
        modulePath: 'packages/cards/src/cards/banyan_shoot.ts',
        exportName: 'BanyanShootCard',
        behaviorTestPath: 'packages/cards/src/cards/banyan_shoot.test.ts',
    },
    {
        id: 'barrier',
        modulePath: 'packages/cards/src/structures/barrier.ts',
        exportName: 'BarrierCard',
        behaviorTestPath: 'packages/cards/src/structures/barrier.test.ts',
    },
    {
        id: 'battle_order',
        modulePath: 'packages/cards/src/cards/battle_order.ts',
        exportName: 'BattleOrderCard',
        behaviorTestPath: 'packages/cards/src/cards/battle_order.test.ts',
    },
    {
        id: 'black_knight',
        modulePath: 'packages/cards/src/cards/black_knight.ts',
        exportName: 'BlackKnightCard',
        behaviorTestPath: 'packages/cards/src/cards/black_knight.test.ts',
    },
    {
        id: 'blackthorn_sapling',
        modulePath: 'packages/cards/src/cards/blackthorn_sapling.ts',
        exportName: 'BlackthornSaplingCard',
        behaviorTestPath: 'packages/cards/src/cards/blackthorn_sapling.test.ts',
    },
    {
        id: 'blind_amoeba',
        modulePath: 'packages/cards/src/cards/blind_amoeba.ts',
        exportName: 'BlindAmoebaCard',
        behaviorTestPath: 'packages/cards/src/cards/blind_amoeba.test.ts',
    },
    {
        id: 'borderland_veteran',
        modulePath: 'packages/cards/src/cards/borderland_veteran.ts',
        exportName: 'BorderlandVeteranCard',
        behaviorTestPath: 'packages/cards/src/cards/borderland_veteran.test.ts',
    },
    {
        id: 'budding_belly',
        modulePath: 'packages/cards/src/cards/budding_belly.ts',
        exportName: 'BuddingBellyCard',
        behaviorTestPath: 'packages/cards/src/cards/budding_belly.test.ts',
    },
    {
        id: 'campaign_armorer',
        modulePath: 'packages/cards/src/cards/campaign_armorer.ts',
        exportName: 'CampaignArmorerCard',
        behaviorTestPath: 'packages/cards/src/cards/campaign_armorer.test.ts',
    },
    {
        id: 'campaign_herald',
        modulePath: 'packages/cards/src/cards/campaign_herald.ts',
        exportName: 'CampaignHeraldCard',
        behaviorTestPath: 'packages/cards/src/cards/campaign_herald.test.ts',
    },
    {
        id: 'clockwork_ottoman',
        modulePath: 'packages/cards/src/cards/clockwork_ottoman.ts',
        exportName: 'ClockworkOttomanCard',
        behaviorTestPath: 'packages/cards/src/cards/clockwork_ottoman.test.ts',
    },
    {
        id: 'colony_attack_bonus',
        modulePath: 'packages/cards/src/cards/colony_attack_bonus.ts',
        exportName: 'ColonyAttackBonusCard',
        behaviorTestPath: 'packages/cards/src/cards/colony_attack_bonus.test.ts',
    },
    {
        id: 'colony_devourer',
        modulePath: 'packages/cards/src/cards/colony_devourer.ts',
        exportName: 'ColonyDevourerCard',
        behaviorTestPath: 'packages/cards/src/cards/colony_devourer.test.ts',
    },
    {
        id: 'colony_predator',
        modulePath: 'packages/cards/src/cards/colony_predator.ts',
        exportName: 'ColonyPredatorCard',
        behaviorTestPath: 'packages/cards/src/cards/colony_predator.test.ts',
    },
    {
        id: 'compost_cycle',
        modulePath: 'packages/cards/src/cards/compost_cycle.ts',
        exportName: 'CompostCycleCard',
        behaviorTestPath: 'packages/cards/src/cards/compost_cycle.test.ts',
    },
    {
        id: 'contamination_map',
        modulePath: 'packages/cards/src/cards/contamination_map.ts',
        exportName: 'ContaminationMapCard',
        behaviorTestPath: 'packages/cards/src/cards/contamination_map.test.ts',
    },
    {
        id: 'cooling_drone',
        modulePath: 'packages/cards/src/overload/cooling-drone.ts',
        exportName: 'CoolingDroneCard',
    },
    {
        id: 'crooked_mirror',
        modulePath: 'packages/cards/src/cards/crooked_mirror.ts',
        exportName: 'CrookedMirrorCard',
        behaviorTestPath: 'packages/cards/src/cards/crooked_mirror.test.ts',
    },
    {
        id: 'crush_and_strain',
        modulePath: 'packages/cards/src/cards/crush_and_strain.ts',
        exportName: 'CrushAndStrainCard',
        behaviorTestPath: 'packages/cards/src/cards/crush_and_strain.test.ts',
    },
    {
        id: 'data_archive',
        modulePath: 'packages/cards/src/cards/data_archive.ts',
        exportName: 'DataArchiveCard',
        behaviorTestPath: 'packages/cards/src/cards/data_archive.test.ts',
    },
    {
        id: 'dazzling_lamp',
        modulePath: 'packages/cards/src/cards/dazzling_lamp.ts',
        exportName: 'DazzlingLampCard',
        behaviorTestPath: 'packages/cards/src/cards/dazzling_lamp.test.ts',
    },
    {
        id: 'deep_sample',
        modulePath: 'packages/cards/src/cards/deep_sample.ts',
        exportName: 'DeepSampleCard',
        behaviorTestPath: 'packages/cards/src/cards/deep_sample.test.ts',
    },
    {
        id: 'defensive_circuit',
        modulePath: 'packages/cards/src/overload/defensive-circuit.ts',
        exportName: 'DefensiveCircuitCard',
    },
    {
        id: 'dining_table',
        modulePath: 'packages/cards/src/cards/dining_table.ts',
        exportName: 'DiningTableCard',
        behaviorTestPath: 'packages/cards/src/cards/dining_table.test.ts',
    },
    {
        id: 'dish_sideboard',
        modulePath: 'packages/cards/src/cards/dish_sideboard.ts',
        exportName: 'DishSideboardCard',
        behaviorTestPath: 'packages/cards/src/cards/dish_sideboard.test.ts',
    },
    {
        id: 'dividing_slime',
        modulePath: 'packages/cards/src/cards/dividing_slime.ts',
        exportName: 'DividingSlimeCard',
        behaviorTestPath: 'packages/cards/src/cards/dividing_slime.test.ts',
    },
    {
        id: 'drop_the_piano',
        modulePath: 'packages/cards/src/cards/drop_the_piano.ts',
        exportName: 'DropThePianoCard',
        behaviorTestPath: 'packages/cards/src/cards/drop_the_piano.test.ts',
    },
    {
        id: 'embroidered_cover',
        modulePath: 'packages/cards/src/cards/embroidered_cover.ts',
        exportName: 'EmbroideredCoverCard',
        behaviorTestPath: 'packages/cards/src/cards/embroidered_cover.test.ts',
    },
    {
        id: 'emergency_vent',
        modulePath: 'packages/cards/src/overload/emergency-vent.ts',
        exportName: 'EmergencyVentCard',
    },
    {
        id: 'erratic_reactor',
        modulePath: 'packages/cards/src/cards/erratic_reactor.ts',
        exportName: 'ErraticReactorCard',
        behaviorTestPath: 'packages/cards/src/cards/erratic_reactor.test.ts',
    },
    {
        id: 'everything_machine',
        modulePath: 'packages/cards/src/swarm/everything-machine.ts',
        exportName: 'EverythingMachineCard',
    },
    {
        id: 'falling_door',
        modulePath: 'packages/cards/src/cards/falling_door.ts',
        exportName: 'FallingDoorCard',
        behaviorTestPath: 'packages/cards/src/cards/falling_door.test.ts',
    },
    {
        id: 'foreign_flesh',
        modulePath: 'packages/cards/src/cards/foreign_flesh.ts',
        exportName: 'ForeignFleshCard',
        behaviorTestPath: 'packages/cards/src/cards/foreign_flesh.test.ts',
    },
    {
        id: 'four_legged_chair',
        modulePath: 'packages/cards/src/cards/four_legged_chair.ts',
        exportName: 'FourLeggedChairCard',
        behaviorTestPath: 'packages/cards/src/cards/four_legged_chair.test.ts',
    },
    {
        id: 'fragment',
        modulePath: 'packages/cards/src/swarm/tokens.ts',
        exportName: 'FragmentCard',
    },
    {
        id: 'furniture_catalog',
        modulePath: 'packages/cards/src/cards/furniture_catalog.ts',
        exportName: 'FurnitureCatalogCard',
        behaviorTestPath: 'packages/cards/src/cards/furniture_catalog.test.ts',
    },
    {
        id: 'general_levy',
        modulePath: 'packages/cards/src/cards/general_levy.ts',
        exportName: 'GeneralLevyCard',
        behaviorTestPath: 'packages/cards/src/cards/general_levy.test.ts',
    },
    {
        id: 'gentle_watering',
        modulePath: 'packages/cards/src/cards/gentle_watering.ts',
        exportName: 'GentleWateringCard',
        behaviorTestPath: 'packages/cards/src/cards/gentle_watering.test.ts',
    },
    {
        id: 'grandmas_blanket',
        modulePath: 'packages/cards/src/cards/grandmas_blanket.ts',
        exportName: 'GrandmasBlanketCard',
        behaviorTestPath: 'packages/cards/src/cards/grandmas_blanket.test.ts',
    },
    {
        id: 'great_banyan',
        modulePath: 'packages/cards/src/cards/great_banyan.ts',
        exportName: 'GreatBanyanCard',
        behaviorTestPath: 'packages/cards/src/cards/great_banyan.test.ts',
    },
    {
        id: 'great_oak_sapling',
        modulePath: 'packages/cards/src/cards/great_oak_sapling.ts',
        exportName: 'GreatOakSaplingCard',
        behaviorTestPath: 'packages/cards/src/cards/great_oak_sapling.test.ts',
    },
    {
        id: 'growth_sunflower',
        modulePath: 'packages/cards/src/cards/growth_sunflower.ts',
        exportName: 'GrowthSunflowerCard',
        behaviorTestPath: 'packages/cards/src/cards/growth_sunflower.test.ts',
    },
    {
        id: 'heat_sink',
        modulePath: 'packages/cards/src/overload/heat-sink.ts',
        exportName: 'HeatSinkCard',
    },
    {
        id: 'hunters_net',
        modulePath: 'packages/cards/src/cards/hunters_net.ts',
        exportName: 'HuntersNetCard',
        behaviorTestPath: 'packages/cards/src/cards/hunters_net.test.ts',
    },
    {
        id: 'impulse_fighter',
        modulePath: 'packages/cards/src/overload/impulse-fighter.ts',
        exportName: 'ImpulseFighterCard',
    },
    {
        id: 'iron_safe',
        modulePath: 'packages/cards/src/cards/iron_safe.ts',
        exportName: 'IronSafeCard',
        behaviorTestPath: 'packages/cards/src/cards/iron_safe.test.ts',
    },
    {
        id: 'ironhide',
        modulePath: 'packages/cards/src/units/ironhide.ts',
        exportName: 'IronhideCard',
    },
    {
        id: 'jelly_bastion',
        modulePath: 'packages/cards/src/cards/jelly_bastion.ts',
        exportName: 'JellyBastionCard',
        behaviorTestPath: 'packages/cards/src/cards/jelly_bastion.test.ts',
    },
    {
        id: 'junk_barricade',
        modulePath: 'packages/cards/src/swarm/junk-barricade.ts',
        exportName: 'JunkBarricadeCard',
    },
    {
        id: 'junk_chest',
        modulePath: 'packages/cards/src/cards/junk_chest.ts',
        exportName: 'JunkChestCard',
        behaviorTestPath: 'packages/cards/src/cards/junk_chest.test.ts',
    },
    {
        id: 'junk_dealer',
        modulePath: 'packages/cards/src/swarm/junk-dealer.ts',
        exportName: 'JunkDealerCard',
    },
    {
        id: 'leaking_clot',
        modulePath: 'packages/cards/src/cards/leaking_clot.ts',
        exportName: 'LeakingClotCard',
        behaviorTestPath: 'packages/cards/src/cards/leaking_clot.test.ts',
    },
    {
        id: 'liquefaction',
        modulePath: 'packages/cards/src/cards/liquefaction.ts',
        exportName: 'LiquefactionCard',
        behaviorTestPath: 'packages/cards/src/cards/liquefaction.test.ts',
    },
    {
        id: 'liquid_cooling',
        modulePath: 'packages/cards/src/overload/liquid-cooling.ts',
        exportName: 'LiquidCoolingCard',
    },
    {
        id: 'living_thornbush',
        modulePath: 'packages/cards/src/cards/living_thornbush.ts',
        exportName: 'LivingThornbushCard',
        behaviorTestPath: 'packages/cards/src/cards/living_thornbush.test.ts',
    },
    {
        id: 'mature_blackthorn',
        modulePath: 'packages/cards/src/cards/mature_blackthorn.ts',
        exportName: 'MatureBlackthornCard',
        behaviorTestPath: 'packages/cards/src/cards/mature_blackthorn.test.ts',
    },
    {
        id: 'meltdown_core',
        modulePath: 'packages/cards/src/cards/meltdown_core.ts',
        exportName: 'MeltdownCoreCard',
        behaviorTestPath: 'packages/cards/src/cards/meltdown_core.test.ts',
    },
    {
        id: 'mercenary_spearman',
        modulePath: 'packages/cards/src/cards/mercenary_spearman.ts',
        exportName: 'MercenarySpearmanCard',
        behaviorTestPath: 'packages/cards/src/cards/mercenary_spearman.test.ts',
    },
    {
        id: 'microdrone',
        modulePath: 'packages/cards/src/swarm/tokens.ts',
        exportName: 'MicrodroneCard',
    },
    {
        id: 'midday_sun',
        modulePath: 'packages/cards/src/cards/midday_sun.ts',
        exportName: 'MiddaySunCard',
        behaviorTestPath: 'packages/cards/src/cards/midday_sun.test.ts',
    },
    {
        id: 'militia',
        modulePath: 'packages/cards/src/cards/militia.ts',
        exportName: 'MilitiaCard',
        behaviorTestPath: 'packages/cards/src/cards/militia.test.ts',
    },
    {
        id: 'mindless_slime',
        modulePath: 'packages/cards/src/cards/mindless_slime.ts',
        exportName: 'MindlessSlimeCard',
        behaviorTestPath: 'packages/cards/src/cards/mindless_slime.test.ts',
    },
    {
        id: 'mnemoslime',
        modulePath: 'packages/cards/src/cards/mnemoslime.ts',
        exportName: 'MnemoslimeCard',
        behaviorTestPath: 'packages/cards/src/cards/mnemoslime.test.ts',
    },
    {
        id: 'morozko_fridge',
        modulePath: 'packages/cards/src/cards/morozko_fridge.ts',
        exportName: 'MorozkoFridgeCard',
        behaviorTestPath: 'packages/cards/src/cards/morozko_fridge.test.ts',
    },
    {
        id: 'nursery_fern',
        modulePath: 'packages/cards/src/cards/nursery_fern.ts',
        exportName: 'NurseryFernCard',
        behaviorTestPath: 'packages/cards/src/cards/nursery_fern.test.ts',
    },
    {
        id: 'overclocked_scout',
        modulePath: 'packages/cards/src/overload/overclocked-scout.ts',
        exportName: 'OverclockedScoutCard',
    },
    {
        id: 'overgrown_roots',
        modulePath: 'packages/cards/src/cards/overgrown_roots.ts',
        exportName: 'OvergrownRootsCard',
        behaviorTestPath: 'packages/cards/src/cards/overgrown_roots.test.ts',
    },
    {
        id: 'overgulper',
        modulePath: 'packages/cards/src/cards/overgulper.ts',
        exportName: 'OvergulperCard',
        behaviorTestPath: 'packages/cards/src/cards/overgulper.test.ts',
    },
    {
        id: 'plant_growth',
        modulePath: 'packages/cards/src/cards/plant_growth.ts',
        exportName: 'PlantGrowthCard',
        behaviorTestPath: 'packages/cards/src/cards/plant_growth.test.ts',
    },
    {
        id: 'plant_leaf',
        modulePath: 'packages/cards/src/cards/plant_leaf.ts',
        exportName: 'PlantLeafCard',
        behaviorTestPath: 'packages/cards/src/cards/plant_leaf.test.ts',
    },
    {
        id: 'plant_thorns',
        modulePath: 'packages/cards/src/cards/plant_thorns.ts',
        exportName: 'PlantThornsCard',
        behaviorTestPath: 'packages/cards/src/cards/plant_thorns.test.ts',
    },
    {
        id: 'power_reroute',
        modulePath: 'packages/cards/src/overload/power-reroute.ts',
        exportName: 'PowerRerouteCard',
    },
    {
        id: 'pull_into_clot',
        modulePath: 'packages/cards/src/cards/pull_into_clot.ts',
        exportName: 'PullIntoClotCard',
        behaviorTestPath: 'packages/cards/src/cards/pull_into_clot.test.ts',
    },
    {
        id: 'rampant_bloom',
        modulePath: 'packages/cards/src/cards/rampant_bloom.ts',
        exportName: 'RampantBloomCard',
        behaviorTestPath: 'packages/cards/src/cards/rampant_bloom.test.ts',
    },
    {
        id: 'reader_armchair',
        modulePath: 'packages/cards/src/cards/reader_armchair.ts',
        exportName: 'ReaderArmchairCard',
        behaviorTestPath: 'packages/cards/src/cards/reader_armchair.test.ts',
    },
    {
        id: 'reconstructed_robot',
        modulePath: 'packages/cards/src/swarm/tokens.ts',
        exportName: 'ReconstructedRobotCard',
    },
    {
        id: 'recycling',
        modulePath: 'packages/cards/src/swarm/recycling.ts',
        exportName: 'RecyclingCard',
    },
    {
        id: 'red_zone',
        modulePath: 'packages/cards/src/overload/red-zone.ts',
        exportName: 'RedZoneCard',
    },
    {
        id: 'reinforced_microdrone',
        modulePath: 'packages/cards/src/swarm/tokens.ts',
        exportName: 'ReinforcedMicrodroneCard',
    },
    {
        id: 'riot_bot',
        modulePath: 'packages/cards/src/units/riot-bot.ts',
        exportName: 'RiotBotCard',
    },
    {
        id: 'riveter',
        modulePath: 'packages/cards/src/swarm/riveter.ts',
        exportName: 'RiveterCard',
    },
    {
        id: 'rootweaver_ivy',
        modulePath: 'packages/cards/src/cards/rootweaver_ivy.ts',
        exportName: 'RootweaverIvyCard',
        behaviorTestPath: 'packages/cards/src/cards/rootweaver_ivy.test.ts',
    },
    {
        id: 'royal_crossbowman',
        modulePath: 'packages/cards/src/cards/royal_crossbowman.ts',
        exportName: 'RoyalCrossbowmanCard',
        behaviorTestPath: 'packages/cards/src/cards/royal_crossbowman.test.ts',
    },
    {
        id: 'royal_decree',
        modulePath: 'packages/cards/src/cards/royal_decree.ts',
        exportName: 'RoyalDecreeCard',
        behaviorTestPath: 'packages/cards/src/cards/royal_decree.test.ts',
    },
    {
        id: 'royal_jelly',
        modulePath: 'packages/cards/src/cards/royal_jelly.ts',
        exportName: 'RoyalJellyCard',
        behaviorTestPath: 'packages/cards/src/cards/royal_jelly.test.ts',
    },
    {
        id: 'sample_collector',
        modulePath: 'packages/cards/src/cards/sample_collector.ts',
        exportName: 'SampleCollectorCard',
        behaviorTestPath: 'packages/cards/src/cards/sample_collector.test.ts',
    },
    {
        id: 'scatter_bolts',
        modulePath: 'packages/cards/src/swarm/scatter-bolts.ts',
        exportName: 'ScatterBoltsCard',
    },
    {
        id: 'scout',
        modulePath: 'packages/cards/src/units/scout.ts',
        exportName: 'ScoutCard',
    },
    {
        id: 'scrap',
        modulePath: 'packages/cards/src/swarm/tokens.ts',
        exportName: 'ScrapCard',
    },
    {
        id: 'scrap_harvester',
        modulePath: 'packages/cards/src/cards/scrap_harvester.ts',
        exportName: 'ScrapHarvesterCard',
        behaviorTestPath: 'packages/cards/src/cards/scrap_harvester.test.ts',
    },
    {
        id: 'scrap_transporter',
        modulePath: 'packages/cards/src/swarm/scrap-transporter.ts',
        exportName: 'ScrapTransporterCard',
    },
    {
        id: 'sector_pulse',
        modulePath: 'packages/cards/src/spells/sector-pulse.ts',
        exportName: 'SectorPulseCard',
        behaviorTestPath: 'packages/cards/src/spells/sector-pulse.test.ts',
    },
    {
        id: 'self_copying_drone',
        modulePath: 'packages/cards/src/swarm/self-copying-drone.ts',
        exportName: 'SelfCopyingDroneCard',
    },
    {
        id: 'shield_bearer',
        modulePath: 'packages/cards/src/cards/shield_bearer.ts',
        exportName: 'ShieldBearerCard',
        behaviorTestPath: 'packages/cards/src/cards/shield_bearer.test.ts',
    },
    {
        id: 'siege_resonator',
        modulePath: 'packages/cards/src/overload/siege-resonator.ts',
        exportName: 'SiegeResonatorCard',
    },
    {
        id: 'single_mass',
        modulePath: 'packages/cards/src/cards/single_mass.ts',
        exportName: 'SingleMassCard',
        behaviorTestPath: 'packages/cards/src/cards/single_mass.test.ts',
    },
    {
        id: 'slime_droplet',
        modulePath: 'packages/cards/src/cards/slime_droplet.ts',
        exportName: 'SlimeDropletCard',
        behaviorTestPath: 'packages/cards/src/cards/slime_droplet.test.ts',
    },
    {
        id: 'slime_residue',
        modulePath: 'packages/cards/src/cards/slime_residue.ts',
        exportName: 'SlimeResidueCard',
        behaviorTestPath: 'packages/cards/src/cards/slime_residue.test.ts',
    },
    {
        id: 'slimefall',
        modulePath: 'packages/cards/src/cards/slimefall.ts',
        exportName: 'SlimefallCard',
        behaviorTestPath: 'packages/cards/src/cards/slimefall.test.ts',
    },
    {
        id: 'slippery_slime',
        modulePath: 'packages/cards/src/cards/slippery_slime.ts',
        exportName: 'SlipperySlimeCard',
        behaviorTestPath: 'packages/cards/src/cards/slippery_slime.test.ts',
    },
    {
        id: 'small_slime',
        modulePath: 'packages/cards/src/cards/small_slime.ts',
        exportName: 'SmallSlimeCard',
        behaviorTestPath: 'packages/cards/src/cards/small_slime.test.ts',
    },
    {
        id: 'soft_sofa',
        modulePath: 'packages/cards/src/cards/soft_sofa.ts',
        exportName: 'SoftSofaCard',
        behaviorTestPath: 'packages/cards/src/cards/soft_sofa.test.ts',
    },
    {
        id: 'spare_part',
        modulePath: 'packages/cards/src/swarm/spare-part.ts',
        exportName: 'SparePartCard',
    },
    {
        id: 'spring_cleaning',
        modulePath: 'packages/cards/src/cards/spring_cleaning.ts',
        exportName: 'SpringCleaningCard',
        behaviorTestPath: 'packages/cards/src/cards/spring_cleaning.test.ts',
    },
    {
        id: 'star_blossom',
        modulePath: 'packages/cards/src/cards/star_blossom.ts',
        exportName: 'StarBlossomCard',
        behaviorTestPath: 'packages/cards/src/cards/star_blossom.test.ts',
    },
    {
        id: 'thermal_inverter',
        modulePath: 'packages/cards/src/cards/thermal_inverter.ts',
        exportName: 'ThermalInverterCard',
        behaviorTestPath: 'packages/cards/src/cards/thermal_inverter.test.ts',
    },
    {
        id: 'thorn_seeds',
        modulePath: 'packages/cards/src/cards/thorn_seeds.ts',
        exportName: 'ThornSeedsCard',
        behaviorTestPath: 'packages/cards/src/cards/thorn_seeds.test.ts',
    },
    {
        id: 'titan_prototype',
        modulePath: 'packages/cards/src/overload/titan-prototype.ts',
        exportName: 'TitanPrototypeCard',
    },
    {
        id: 'trash_critter',
        modulePath: 'packages/cards/src/swarm/trash-critter.ts',
        exportName: 'TrashCritterCard',
    },
    {
        id: 'venus_flytrap',
        modulePath: 'packages/cards/src/cards/venus_flytrap.ts',
        exportName: 'VenusFlytrapCard',
        behaviorTestPath: 'packages/cards/src/cards/venus_flytrap.test.ts',
    },
    {
        id: 'voltaic_accumulator',
        modulePath: 'packages/cards/src/cards/voltaic_accumulator.ts',
        exportName: 'VoltaicAccumulatorCard',
        behaviorTestPath: 'packages/cards/src/cards/voltaic_accumulator.test.ts',
    },
    {
        id: 'wandering_healer',
        modulePath: 'packages/cards/src/cards/wandering_healer.ts',
        exportName: 'WanderingHealerCard',
        behaviorTestPath: 'packages/cards/src/cards/wandering_healer.test.ts',
    },
    {
        id: 'welding_pulse',
        modulePath: 'packages/cards/src/swarm/welding-pulse.ts',
        exportName: 'WeldingPulseCard',
    },
]);
export const generatedGameCards = Object.freeze([
    generatedCard0,
    generatedCard1,
    generatedCard2,
    generatedCard3,
    generatedCard4,
    generatedCard5,
    generatedCard6,
    generatedCard7,
    generatedCard8,
    generatedCard9,
    generatedCard10,
    generatedCard11,
    generatedCard12,
    generatedCard13,
    generatedCard14,
    generatedCard15,
    generatedCard16,
    generatedCard17,
    generatedCard18,
    generatedCard19,
    generatedCard20,
    generatedCard21,
    generatedCard22,
    generatedCard23,
    generatedCard24,
    generatedCard25,
    generatedCard26,
    generatedCard27,
    generatedCard28,
    generatedCard29,
    generatedCard30,
    generatedCard31,
    generatedCard32,
    generatedCard33,
    generatedCard34,
    generatedCard35,
    generatedCard36,
    generatedCard37,
    generatedCard38,
    generatedCard39,
    generatedCard40,
    generatedCard41,
    generatedCard42,
    generatedCard43,
    generatedCard44,
    generatedCard45,
    generatedCard46,
    generatedCard47,
    generatedCard48,
    generatedCard49,
    generatedCard50,
    generatedCard51,
    generatedCard52,
    generatedCard53,
    generatedCard54,
    generatedCard55,
    generatedCard56,
    generatedCard57,
    generatedCard58,
    generatedCard59,
    generatedCard60,
    generatedCard61,
    generatedCard62,
    generatedCard63,
    generatedCard64,
    generatedCard65,
    generatedCard66,
    generatedCard67,
    generatedCard68,
    generatedCard69,
    generatedCard70,
    generatedCard71,
    generatedCard72,
    generatedCard73,
    generatedCard74,
    generatedCard75,
    generatedCard76,
    generatedCard77,
    generatedCard78,
    generatedCard79,
    generatedCard80,
    generatedCard81,
    generatedCard82,
    generatedCard83,
    generatedCard84,
    generatedCard85,
    generatedCard86,
    generatedCard87,
    generatedCard88,
    generatedCard89,
    generatedCard90,
    generatedCard91,
    generatedCard92,
    generatedCard93,
    generatedCard94,
    generatedCard95,
    generatedCard96,
    generatedCard97,
    generatedCard98,
    generatedCard99,
    generatedCard100,
    generatedCard101,
    generatedCard102,
    generatedCard103,
    generatedCard104,
    generatedCard105,
    generatedCard106,
    generatedCard107,
    generatedCard108,
    generatedCard109,
    generatedCard110,
    generatedCard111,
    generatedCard112,
    generatedCard113,
    generatedCard114,
    generatedCard115,
    generatedCard116,
    generatedCard117,
    generatedCard118,
    generatedCard119,
    generatedCard120,
    generatedCard121,
]);
//# sourceMappingURL=generated-cards.js.map